import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

//Components
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RegistroComponent } from './registro/registro.component';
import { IniciarSesionComponent } from './iniciar-sesion/iniciar-sesion.component';

//Modules
import { UtilModule } from '../util/util.module';
import { IconsModule } from '../icons/icons.module';
import { LoginRoutingModule } from './login-routing.module';


import {sharedImputDirectiveModule} from 'src/app/util/sharedInput.module';
import { Mugan86GoogleAnalyticsModule } from 'mugan86-ng-google-analytics';
import { environment } from 'src/environments/environment';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { VerifyCodeComponent } from './verify-code/verify-code.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegistroComponent,
    IniciarSesionComponent,
    VerifyEmailComponent,
    VerifyCodeComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UtilModule,
    RouterModule,
    IconsModule,
    LoginRoutingModule,
    sharedImputDirectiveModule,
    Mugan86GoogleAnalyticsModule.forRoot(
      {
        analyticsId: environment.POINT_GOOGLE_ANALYTICS,
        showLog: false
      }
    )
  ],
  exports: [
    LoginComponent,
    RegistroComponent,
    IniciarSesionComponent,
    VerifyEmailComponent,
    VerifyCodeComponent
  ]
})
export class LoginModule { }
